import styled from 'styled-components';

import {
	useCustomTheme,
	makeStandartMargins,
} from '../../styles';
import { InputStandartMargins } from '../text-field';


type RootProps = {
	fullWidth?: boolean;
	margin?: InputStandartMargins;
}

type SuggestionProps = {
	highlight?: boolean;
}

const Root = styled.div<RootProps>`
	position: relative;
	display: inline-block;
	width: auto;
	height: auto;

	${p => p.margin && `
		${makeStandartMargins(p.margin)};
	`}

	& .MuiInputBase-input {
		padding-right: 20px;
	}

	& .MuiInputAdornment-root i {
		cursor: pointer;
	}

	& .MuiInputBase-inputAdornedEnd {
		padding-right: 51px;
	}

	${p => p.fullWidth && `
		width: 100%;
	`}

	${p => !p.fullWidth && `
		& .MuiInputBase-root {
			width: calc(100% - 20px);
		}
	`}
`;

const Suggestion = styled.span<SuggestionProps>`
	${p => p.highlight && `
		color: ${useCustomTheme(p)[0].color.accentPrimary};
	`}
`;


export {
	Root,
	Suggestion,
};
